import { MutableRefObject, useEffect } from 'react';


export const useOutOfElDetection = (ref: any, method: (state: boolean) => void) => {
  const detectClickOutside = ({ target }: MouseEvent) => {
    const { current }: MutableRefObject<any> = ref;
    if (current && !current.contains(target as Node)) {
      method(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', detectClickOutside);
    return () => {
      document.removeEventListener('click', detectClickOutside);
    };
  }, []);

  return;
};
